import request from '@/utils/request';

// 模拟登录
export function login() {
  return request({
    url: '/app-api/xiangyun/authentication/testLogin',
    method: 'get'
  });
}

// 获取二维码
export function generateCode() {
  return request({
    url: '/app-api/xiangyun/authentication/qr/pc/generateQr',
    method: 'get'
  });
}

// 获取二维码状态
export function codeStatus(id) {
  return request({
    url: "/app-api/xiangyun/authentication/qr/pc/getQr?id=".concat(id),
    method: 'get'
  });
}

// 获取token
export function getToken(data) {
  return request({
    url: '/app-api/xiangyun/authentication/qr/pc/getToken',
    method: 'post',
    data: data
  });
}

// 获取用户信息
export function getUser() {
  return request({
    url: '/app-api/xiangyun/user-info/getUserInfo'
  });
}

// 获取企业列表
export function getCompanyList() {
  return request({
    url: '/app-api/xiangyun/erp-info/list',
    method: 'post',
    data: {
      erpName: ''
    }
  });
}

// 切换企业
export function selCurrent(data) {
  return request({
    url: '/app-api/xiangyun/erp-info/option',
    method: 'post',
    data: data
  });
}
export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  });
}